import PropTypes from "prop-types";
import React from "react";

const useStyles = () => ({
  container: {
    height: "80dvh",
  },
  tableWrapper: {
    height: "90%",
  },
  tableInnerWrapper: {
    height: "100%",
    marginTop: "1rem",
    backgroundColor: "#FFFFFF",
    padding: "1rem",
    borderRadius: "10px",
    boxShadow: "rgba(99, 99, 99, 0.2) 0px 0px 8px 2px",
  },
});

const TableLayout = ({ header, children, styles}) => {
  const classes = useStyles();

  return (
<div style={{ ...classes.container, ...styles?.container }}>
  <div data-testid="table" style={{ ...classes.tableWrapper, ...styles?.tableWrapper }}>
    {header}
    <div style={{ ...classes.tableInnerWrapper, ...styles?.tableInnerWrapper }}>
      {children}
    </div>
  </div>
</div>
  );
};

export default TableLayout;

TableLayout.propTypes = {
  header: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  styles: PropTypes.object,
};
